// use esversion: 6
import React, { Component } from "react";

class CPLLogo extends Component {
  render() {
    return (
      <svg
        id="CPL-Full-Logo"
        className={this.props.className}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 110">
        <g fill={this.props.fill}>
          <path
            d="M56.139,109.5C20.669,109.5,1,85.474,1,55.802C1,25.333,24.216,0.5,61.784,0.5c10.319,0,20.475,1.776,27.895,5.482
		l-0.484,21.929c-9.672-5.644-19.025-7.093-26.278-7.093c-25.317,0-34.989,16.927-34.989,33.86c0,19.026,12.575,34.343,32.57,34.343
		c9.993,0,18.22-2.578,26.763-7.253l6.452,18.057C80.646,106.919,68.714,109.5,56.139,109.5z"
          />
          <path d="M105.968,107.887V1.628h24.507v86.264h36.601v19.995H105.968z" />
          <path
            d="M264.951,93.212c-10.001,10.155-23.863,16.288-40.796,16.288c-16.126,0-29.023-4.522-38.537-12.901
		c-10.962-9.836-16.929-24.186-16.929-40.472c0-15.637,5.483-29.669,15.48-39.826C193.84,6.465,207.548,0.5,224.154,0.5
		c17.739,0,32.248,5.965,41.92,16.285c9.033,9.672,13.381,22.898,13.381,37.729C279.456,69.511,274.623,83.54,264.951,93.212z
		 M223.991,20.169c-16.77,0-29.667,12.579-29.667,34.99c0,22.415,12.897,34.991,29.667,34.991c16.448,0,29.346-12.577,29.346-34.991
		C253.337,32.748,240.439,20.169,223.991,20.169z"
          />
          <path
            d="M377.013,96.761c-8.223,8.38-20.154,12.739-36.92,12.739c-16.126,0-28.38-3.389-36.438-11.288
		c-6.776-6.614-10.483-16.608-10.483-29.83V1.628h24.508v64.494c0,7.906,2.419,12.738,5.481,16.291
		c3.869,4.513,10.318,6.608,17.25,6.608c8.226,0,14.193-2.258,18.062-6.446c3.384-3.715,4.996-8.871,4.996-15.484V1.628h24.67
		v63.369C388.138,78.7,384.27,89.504,377.013,96.761z"
          />
          <path
            d="M441.673,107.887h-35.796V1.628h38.377c37.246,0,59.495,19.996,59.495,52.245
		C503.749,87.407,477.631,107.887,441.673,107.887z M441.836,21.782h-11.288v66.11h11.772c24.666,0,34.826-15.8,34.826-33.214
		C477.146,34.04,464.73,21.782,441.836,21.782z"
          />
          <path
            d="M544.869,73.061h-2.742v34.826h-24.67V1.628h30.796c23.704,0,39.824,12.091,39.824,35.637
		C588.077,54.03,577.923,73.061,544.869,73.061z M545.676,21.464h-3.549v31.759h3.549c12.253,0,18.06-5.802,18.06-15.958
		C563.735,28.717,557.767,21.464,545.676,21.464z"
          />
          <path d="M603.884,107.887V1.628h24.67v106.259H603.884z" />
          <path d="M649.515,107.887V1.628h24.507v86.264h36.604v19.995H649.515z" />
          <path
            d="M808.497,93.212c-9.998,10.155-23.866,16.288-40.798,16.288c-16.122,0-29.018-4.522-38.531-12.901
		c-10.963-9.836-16.932-24.186-16.932-40.472c0-15.637,5.48-29.669,15.482-39.826C737.39,6.465,751.095,0.5,767.699,0.5
		c17.74,0,32.255,5.965,41.926,16.285c9.03,9.672,13.381,22.898,13.381,37.729C823.006,69.511,818.172,83.54,808.497,93.212z
		 M767.542,20.169c-16.771,0-29.669,12.579-29.669,34.99c0,22.415,12.898,34.991,29.669,34.991
		c16.446,0,29.345-12.577,29.345-34.991C796.887,32.748,783.988,20.169,767.542,20.169z"
          />
          <path d="M911.226,21.464h-28.059v86.422h-24.993V21.464h-31.115V1.628h89.32L911.226,21.464z" />
          <path
            d="M958.95,109.5c-15.798,0-27.087-5.164-35.146-10.481l9.353-17.578c7.095,4.838,15.154,8.545,24.507,8.545
		c7.257,0,15.317-2.579,15.317-9.832c0-12.737-25.961-14.838-38.7-29.67c-4.03-4.675-6.609-10.641-6.609-18.864
		c0-16.289,13.061-31.12,37.409-31.12c11.283,0,21.121,2.9,27.732,6.614l-0.483,20.639c-9.836-5.001-17.088-7.901-25.795-7.901
		c-7.422,0-12.739,3.384-12.739,8.543c0,16.929,45.304,14.994,45.304,48.693C999.1,97.243,981.203,109.5,958.95,109.5z"
          />
        </g>
      </svg>
    );
  }
}

export default CPLLogo;



// WEBPACK FOOTER //
// ./src/appBar/CPLLogo.js